import { GridRowId } from "@mui/x-data-grid";
import {
  SET_SELECTED_CLAIM_TYPE,
  SET_SELECTED_CLAIM_SUB_TYPE,
  SET_IN_CLAIM_SUMMARY_PAGE,
  SET_MONTH,
  SET_SEARCH_TEXT,
  SET_CHECKED_CLAIM_IDS,
  SET_CLAIM_IDS_CHECKBOX_HIDDEN,
  SET_OPEN,
  SET_SELECTED_ROW_TO_EDIT,
  SET_DISABLE_EDITING,
  SET_ADD_RETURN_MODAL_VISIBLE,
  SET_RETURN_PRODUCTS_ARRAY,
  SET_RETURN_PRODUCT_OBJECT,
  SET_BATCH_IDS_EXPANDED,
  SET_CHECKED_BATCHES,
  SET_APPROVAL_MODAL_OPEN,
  SET_APPROVAL_MODAL_STATE,
  SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX,
  SET_RETURN_PRODUCT_OBJECT_INITIAL,
  SET_RETURN_PRODUCT_OBJECT_ORIGINAL,
  SET_CLAIM_SUMMARY_ROWS,
  SET_SALE_RETURNS_ROWS,
  SET_INITIAL_SALE_RETURNS_ROWS,
  SET_INITIAL_SECONDARY_SCHEMES_ROW,
  SET_SECONDARY_SCHEMES_ROW,
  SET_SELECTED_SECONDARY_SCHEMES_ROW,
  SET_SELECTED_INVOICE_ROW,
  SET_TOTAL_ORDER_VALUE_ROW,
  SET_SELECTED_TOTAL_ORDER_VALUE_ROW,
  SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS,
  RESET_CLAIMS_STATE,
  SET_DISCOUNT_MODAL_STATE,
  SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS,
  SET_EDITED_BATCHES,
  SET_OPEN_CLAIMS_ROWS,
  SET_SELECTED_OPEN_CLAIMS_ROW,
  SET_VIEW_CLAIMS_ROWS,
  SET_SELECTED_VIEW_CLAIMS_ROW,
  SET_NON_ELIGIBLE
} from "../types/claimTypes";


export const resetClaimsState = () => ({
  type: RESET_CLAIMS_STATE,
});

export const setDiscountModalState = (modalState: any) => ({
  type:  SET_DISCOUNT_MODAL_STATE ,
  payload: modalState,
});

export const setOpenClaimsRow = (row: any) => ({
  type:  SET_OPEN_CLAIMS_ROWS,
  payload: row,
});

export const setSelectedOpenClaimsRow = (row: any) => ({
  type:  SET_SELECTED_OPEN_CLAIMS_ROW,
  payload: row,
});

export const setViewClaimsRow = (row: any) => ({
  type:  SET_VIEW_CLAIMS_ROWS,
  payload: row,
});

export const setSelectedViewClaimsRow = (row: any) => ({
  type:  SET_SELECTED_VIEW_CLAIMS_ROW,
  payload: row,
});

export const setSelectedSecondarySchemesRow = (row: any) => ({
  type:  SET_SELECTED_SECONDARY_SCHEMES_ROW,
  payload: row,
});

export const setSelectedInvoiceRow = (row: any) => ({
  type: SET_SELECTED_INVOICE_ROW,
  payload: row
});

export const setInitialSecondarySchemesRows = (initialSecondarySchemesRows: any[]) => ({
  type: SET_INITIAL_SECONDARY_SCHEMES_ROW,
  payload: initialSecondarySchemesRows,
});

export const setSecondarySchemesRows = (secondarySchemesRows: any[]) => ({
  type: SET_SECONDARY_SCHEMES_ROW,
  payload: secondarySchemesRows,
});

export const setTotalOrderValueRows = (totalOrderValueRows: any) => ({
  type:  SET_TOTAL_ORDER_VALUE_ROW,
  payload: totalOrderValueRows,
});

export const setSelectedTotalOrderValueRows = (selectedTotalOrderValueRow: any) => ({
  type:  SET_SELECTED_TOTAL_ORDER_VALUE_ROW,
  payload: selectedTotalOrderValueRow,
});

export const setTotalOrderValueCheckedClaimIds = (ids: any) => ({
  type:    SET_TOTAL_ORDER_VALUE_CHECKED_CLAIM_IDS,
  payload: ids,
});

export const setSaleReturnRows = (saleReturnsRows: any[]) => ({
  type: SET_SALE_RETURNS_ROWS,
  payload: saleReturnsRows,
});

export const setInitialSaleReturnsRows = (initialSaleReturnsRows: any[]) => ({
  type: SET_INITIAL_SALE_RETURNS_ROWS,
  payload: initialSaleReturnsRows,
});

export const setClaimSummaryRows = (claimSummaryRows: any[]) => ({
  type: SET_CLAIM_SUMMARY_ROWS,
  payload: claimSummaryRows,
});

export const setSelectedClaimType = (claimType: string) => ({
  type: SET_SELECTED_CLAIM_TYPE,
  payload: claimType,
});

export const setSelectedClaimSubType = (claimSubType: string) => ({
  type: SET_SELECTED_CLAIM_SUB_TYPE,
  payload: claimSubType,
});

export const setInClaimSummaryPage = (inSummaryPage: boolean) => ({
  type: SET_IN_CLAIM_SUMMARY_PAGE,
  payload: inSummaryPage,
});

export const setMonth = (month: string) => ({
  type: SET_MONTH,
  payload: month,
});

export const setSearchText = (searchText: string) => ({
  type: SET_SEARCH_TEXT,
  payload: searchText,
});

export const setSaleReturnsCheckedClaimIds = (saleReturnsCheckedClaimIds: GridRowId[]) => ({
  type: SET_CHECKED_CLAIM_IDS,
  payload: saleReturnsCheckedClaimIds,
});

export const setOpenClaimsDetailsCheckedClaimIds = (saleReturnsCheckedClaimIds: GridRowId[]) => ({
  type: SET_CHECKED_CLAIM_IDS,
  payload: saleReturnsCheckedClaimIds,
});

export const setSaleReturnsClaimIdsCheckboxHidden = (saleReturnsClaimIdsCheckboxHidden: GridRowId[]) => ({
  type: SET_CLAIM_IDS_CHECKBOX_HIDDEN,
  payload: saleReturnsClaimIdsCheckboxHidden,
});

export const setSecondarySchemesCheckedClaimIds = (secondarySchemesCheckedClaimIds: GridRowId[]) => ({
  type: SET_SECONDARY_SCHEMES_CHECKED_CLAIM_IDS,
  payload: secondarySchemesCheckedClaimIds,
});

export const setOpen = (open: boolean) => ({
  type: SET_OPEN,
  payload: open,
});

export const setSelectedRowToEdit = (row: any | null) => ({
  type: SET_SELECTED_ROW_TO_EDIT,
  payload: row,
});

export const setDisableEditing = (disable: boolean) => ({
  type: SET_DISABLE_EDITING,
  payload: disable,
});

export const setAddReturnModalVisible = (visible: boolean) => ({
  type: SET_ADD_RETURN_MODAL_VISIBLE,
  payload: visible,
});

export const setReturnProductsArray = (products: any[]) => ({
  type: SET_RETURN_PRODUCTS_ARRAY,
  payload: products,
});

export const setReturnProductObject = (product: object) => ({
  type: SET_RETURN_PRODUCT_OBJECT,
  payload: product,
});

export const setBatchIdsExpanded = (expanded: boolean) => ({
  type: SET_BATCH_IDS_EXPANDED,
  payload: expanded,
});

export const setCheckedBatches = (batches: any[]) => ({
  type: SET_CHECKED_BATCHES,
  payload: batches,
});

export const setEditedBatches = (payload: Array<{ skuCode: string; batchIds: string[] }>) => ({
  type: SET_EDITED_BATCHES,
  payload
});

export const setApprovalModalOpen = (open: boolean) => ({
  type: SET_APPROVAL_MODAL_OPEN,
  payload: open,
});

export const setApprovalModalState = (state: number) => ({
  type: SET_APPROVAL_MODAL_STATE,
  payload: state,
});

export const setSelectedReturnProductArrayIdx = (index: any | null) => ({
  type: SET_SELECTED_RETURN_PRODUCT_ARRAY_IDX,
  payload: index,
});

export const setReturnProductObjectInitial = (initial: any) => ({
  type: SET_RETURN_PRODUCT_OBJECT_INITIAL,
  payload: initial,
});

export const setReturnProductObjectOriginal = (original: any) => ({
  type: SET_RETURN_PRODUCT_OBJECT_ORIGINAL,
  payload: original,
});

export const setNonEligible = (details: any) => ({
  type: SET_NON_ELIGIBLE,
  payload: details,
});
